// pages/forgot-password.tsx
import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { sendForgotPasswordEmail } from "@/services/authService";
import { enqueueSnackbar } from "notistack";
import { ArrowBack } from "@mui/icons-material";
import { routes } from "@/constants/routes";
import theme from "@/constants/theme";
import Input from "@/components/input/Input";
import Button from "@/components/input/Button";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSendEmail = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      await sendForgotPasswordEmail(email);
      enqueueSnackbar({
        variant: "success",
        message: "Te hemos enviado un enlace para recuperar tu contraseña.",
      });
      navigate("/");
    } catch (error) {
      enqueueSnackbar({
        variant: "error",
        message: "No se pudo enviar el correo de recuperación.",
      });
    }
  };

  const goBack = () => navigate(-1);

  return (
    <div style={styles.container}>
      <Link to={routes.welcome} style={styles.homeIcon}>
        <ArrowBack />
      </Link>
      <form style={styles.form} onSubmit={handleSendEmail}>
        <h1 style={styles.title}>¿Olvidaste tu contraseña?</h1>
        <p style={styles.subtitle}>
          Ingresá tu correo electrónico y te enviaremos un enlace para
          restablecerla.
        </p>
        <Input
          type="email"
          label="Correo electrónico"
          placeholder="Escribe tu correo electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button sx={styles.button}>
          Enviar enlace
        </Button>
      </form>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    backgroundColor: theme.colors.background.primary,
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: 32,
    paddingRight: 32,
    position: "relative",
  },
  homeIcon: {
    position: "absolute",
    top: 40,
    left: 24,
    color: theme.colors.text.default,
  },
  background: {
    flex: 1,
    justifyContent: "center",
    paddingLeft: 32,
    paddingRight: 32,
    position: "relative",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
    width: 400,
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#DEE7E7",
    textAlign: "center",
    marginBottom: "16px",
  },
  subtitle: {
    fontSize: 16,
    color: theme.colors.text.body,
    textAlign: "center",
    marginBottom: 24,
  },
  input: {
    height: 48,
    borderWidth: 1,
    borderColor: "#DEE7E7",
    borderRadius: 8,
    paddingLeft: 12,
    paddingRight: 12,
    marginBottom: 16,
    color: "#0F1A3D",
    backgroundColor: "#fff",
  },
  button: {
    justifyContent: "center",
    fontWeight: "bold",
    marginTop: 26,
  },
  buttonText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: 16,
  },
};
